import { SELF_PACED_COLLABORATORS } from "./constants";

export function getIsDefaultCollaborator(name: string): boolean {
  return (Object.values(SELF_PACED_COLLABORATORS) as string[]).includes(name);
}
